/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext } from "react";
import type {
  PagesMap,
  PageComponents,
  GetPageKey,
  GetPageId,
  GoToPage,
  GoToNextPage,
  GoToPrevPage,
} from "./provider";

export type PageConfigContextType = {
  currentPage: number;
  pagesMap: PagesMap;
  pageComponents:PageComponents;
  getPageKey: GetPageKey;
  getPageId: GetPageId;
  goToPage: GoToPage;
  goToNextPage: GoToNextPage;
  goToPrevPage: GoToPrevPage;
};

export const PageConfigContext = createContext<PageConfigContextType>({
  currentPage: 0,
  pagesMap: {},
  pageComponents: {},
  getPageKey: (pageId) => null,
  getPageId: (pageKey) => 0,
  goToPage: (pageKeyOrId) => {},
  goToNextPage: () => {},
  goToPrevPage: () => {},
});

export default PageConfigContext;

export const usePageConfig = () => useContext(PageConfigContext);
